import ApiService, { ISSUES_API_HOST } from './ApiService';

/**
 * @override
 */
class IssuesService extends ApiService {
    /**
     * constructor
     */
    constructor() {
        super({ baseURL: ISSUES_API_HOST });
    }

    create(issue) {
        return this.post('/issues', issue);
    }
}

const issueService = new IssuesService();

export default issueService;
